export class SkipIfi {
  constructor() {}

  init(ref) {
    this.addSkip();
    this.nextVidRef = ref;
  }
  addSkip() {
    let _streamingPlayer = $(".streaming-video-player.amp-player");
    let _skipButton = `<div class="eed-skip">
    <p class="eed-skip-text">Program will commence after this Information from Industry.</p>
    <button class="eed-skip-button">Skip</button>
    <div class="close"></div>
    </div>`;
    if (_streamingPlayer.length == 1) {
      _streamingPlayer.append(_skipButton);
      $(".eed-skip .close").click(() => {
        this.closeSkip();
      });
      $(".eed-skip-button").click(() => {
        this.skipAd();
      });
    }
  }
  closeSkip() {
    $(".eed-skip").hide();
    const _persistant = $(".persistent-header.skip");
    if (_persistant.length > 0) {
      _persistant.removeClass("skip");
    }
  }
  skipAd() {
    $(this.nextVidRef).click();
    this.closeSkip();
  }
}
